import React from 'react';
import { useLocation } from 'react-router-dom';
import MatchingPhaseSidebar from './MatchingPhaseSidebar';
import OverviewBase from '../OverviewBase';
import { Campaign } from '../../../../types/Campaign';
import MatchingPanelOptimized from './MatchingPanel';
import ApplicationDashboard from './ApplicationDashboard';
import TimelineEventsDates from './TimelineEventsDates';
import Kickoff from './Kickoff';

const MatchingOverview = () => {
    const location = useLocation();
    const { pathname } = location;

    // Extract the last segment of the path
    const pathSegments = pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];

    // Determine which component to render based on the current route
    const renderContentByRoute = ({ campaign, onSave, onPendingChanges }: {
        campaign: Campaign;
        onSave: (updatedCampaign: Partial<Campaign>) => Promise<Campaign>;
        onPendingChanges: (changes: Partial<Campaign>) => void;
    }) => {
        switch (lastSegment) {
            case 'application-dashboard':
                return <ApplicationDashboard campaign={campaign} />;
            case 'matching':
                return <MatchingPanelOptimized campaign={campaign} />;
            case 'dates':
                return <TimelineEventsDates campaign={campaign} onSave={onSave} />;
            case 'kickoff':
                return <Kickoff campaign={campaign} />;
            case 'overview':
            default:
                return <MatchingPanelOptimized campaign={campaign} />;
        }
    };

    return (
        <OverviewBase
            renderSidebar={() => (
                <MatchingPhaseSidebar
                    sidebarCollapsed={false}
                />
            )}
            renderContent={renderContentByRoute}
        />
    );
};

export default MatchingOverview;